import React from 'react';

import CourseItem from '../course-item/CourseItem';
import LiveItem from '../live-item/live-item';
import SimpleSlider from '../simple-slider';

type Props = {
  courses: any[];
  weekOrder: number;
};

const CoursesSlider: React.FC<Props> = ({ courses, weekOrder }) => {
  return (
    <SimpleSlider>
      {courses.map((course, i) =>
        course.lessons ? (
          <CourseItem key={i} course={course} weekOrder={weekOrder} />
        ) : (
          <LiveItem key={i} live={course} />
        ),
      )}
    </SimpleSlider>
  );
};

export default CoursesSlider;
